/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Mst Interface
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface ItemParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Item {
  id?:number;
  code:string;
  name:string;
  description:string;
  taxable:string;
  exemptionReason:string;
  productType:string;
  source:string;
  referenceId:string;
  status:string;
  usageUnit:any;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  billableItem :string;
  tenantId:any;
  createdIP:string;
  updatedIP:string;
  itemSubCategoryId: string,
    itemCategoryId: string,
    itemManufaId: string,
    productModel: string,
    itemSKUASIN: string,
    hcpcsCode: string,
    barCode: string,
    qrCode: string,
    standardSellPrice: string,
    valuationRate: string,
    reOrderLevel: string,
    reOrderQty: string,
    defaultWarehouse: string,
    defaultSupplier: string,
    itemSerialNo: string,
    isfixedAsset: string,
    maintainStock: string,
    hsnsacCode: string,
    gstper: number,
    imageURL: string
    
  parameters?: ItemParameter[];
  links?: any;
}

export abstract class ItemData { 
  abstract list(url: string): Observable<Item[]>;
  abstract create(url: string,data: Item): Observable<any>;
  abstract update(url: string,data: Item): Observable<any>;
  abstract delete(url: string): Observable<any>;
}